import React from 'react'
import { graphql } from 'gatsby'
import SvgSafeGatsbyImage from '@atoms/SvgSafeGatsbyImage'

import Container from '@atoms/Container'
import RichTextEditorStyles from '@utils/RichTextEditorStyles'
import paddingDefault from '@utils/paddingDefault'
import apCaseOnlyTitleTags from '@utils/apCaseOnlyTitleTags'
import { colors } from '../primitives/colors'

// this is not being used as of Jan 2024
// TODO: confirm and remove from contentstack if not relevant 
const ContactBanner = ({ data }) => {
  const { content } = data || ''
  const { headline, subline, copy, image } =
    !!content && !!content[0] ? content[0] : ''

  return (
    <div css={[paddingDefault(), styles.containerWrap]}>
      <Container>
        <div css={styles.contentWrap}>
          <h4 css={styles.subline}>{subline}</h4>
          <h3 css={styles.headline}>
            {apCaseOnlyTitleTags(headline)}
          </h3>
          <div
            css={[RichTextEditorStyles, styles.copy]}
            dangerouslySetInnerHTML={{ __html: copy }}
          />
        </div>
      </Container>
      {image?.url && (
        <div css={styles.descriptionWrap}>
          <SvgSafeGatsbyImage css={styles.image} image={image} alt={image.description} />
        </div>
      )}
    </div>
  )
};

const styles = {
  copy: {
    fontSize: "1.125rem",
    lineHeight: "1.75rem"
  },
  contentWrap: {
    position: "relative",
    zIndex: 10,
    paddingLeft: "1rem",
    paddingRight: "1rem",
    color: colors.shadesWhite,
    maxWidth: "634px"
  },
  containerWrap: {
    position: "relative"
  },
  subline: {
    marginTop: "0.5rem",
    marginBottom: "1rem",
    fontSize: "1.125rem",
    lineHeight: "1.75rem"
  },
  headline: {
    fontSize: "54px",
    marginBottom: "1rem",
    lineHeight: "2.5rem",
    "@media (min-width: 1024px)": {
      marginBottom: "0",
      fontSize: "3.75rem",
      lineHeight: 1.25
    },
    descriptionWrap: {
      position: "absolute",
      top: "0",
      right: "0",
      bottom: "0",
      left: "0"
    }
  },
  image: {
    objectFit: "cover",
    position: "absolute",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0",
    width: "100%",
    height: "100%"
  }
};

export const query = graphql`
  fragment ContactBannerData on CmsPageBuilderBlocks {
    contact_banner {
      content {
        headline
        subline
        copy
        image {
          filename
          title
          url
          description
          contentStackAsset(width: 1440)
        }
      }
    }
  }
`;

export default ContactBanner;
